export enum BusinessType {
	free = 'free',
	premium = 'premium',
}
